let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hqBP4")).then(() => parcelRequire('7QpWr'));